import React from 'react';
import { useTeamLogo, useTeams } from '../hooks/team';
import { getTeamUrl } from '../utils/routes';

function TeamLogo({ team }) {
  const [logo] = useTeamLogo(team.abbrv);

  if (!logo) {
    return null;
  }

  return (
    <a className="team-logo-carousel__item" href={getTeamUrl(team.abbrv)}>
      <img src={logo} alt={team.name} />
    </a>
  );
}

export default function TeamLogosCarousel() {
  const [teams] = useTeams();

  if (!teams) {
    return null;
  }

  return (
    <>
      <h2 className="heading-h6 heading-sm-h3 text-shadow">Lagsidor</h2>
      <div className="team-logo-carousel px-2 py-4 mb-4">
        {teams.map((team) => (
          <TeamLogo team={team} />
        ))}
      </div>
    </>
  );
}
